import React from 'react';
import { Typography } from 'antd';
import {
  TableCell,
  TableFilter,
  TableSortLabel,
} from '../../../../../../components/customTableComponents';
import styles from './CallListHeadCell.module.scss';

const renderTitle = (title) => {
  if (!title) return null;

  return <Typography.Text className={styles.text}>{title}</Typography.Text>;
};

const SortContainer = ({ hasSort, onSortClick, children, direction }) => {
  if (!hasSort) return children;

  return (
    <TableSortLabel onSortClick={onSortClick} direction={direction}>
      {children}
    </TableSortLabel>
  );
};

const CallListHeadCell = ({
  column,
  onSortClick,
  direction,
  onFilterConfirm,
  onFilterReset,
  selectedItems,
  filtered,
  filterItems,
}) => {
  return (
    <TableCell
      component="th"
      className={styles.cell}
      style={{ width: column.width }}
    >
      <SortContainer
        hasSort={Boolean(column.sortType)}
        onSortClick={onSortClick}
        direction={direction}
      >
        <div className={styles.container}>
          {renderTitle(column.title)}
          {column.filterKey && (
            <TableFilter
              filterItems={filterItems}
              filterMultiple={column.filterMultiple}
              onConfirm={onFilterConfirm}
              onReset={onFilterReset}
              selectedItems={selectedItems}
              filtered={filtered}
            />
          )}
        </div>
      </SortContainer>
    </TableCell>
  );
};

export default CallListHeadCell;
